import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    Chip,
    List,
    ListItem,
    ListItemText
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

const Step3View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const InfoField: React.FC<{ label: string; value: any }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Typography variant="body1">
                {value || 'Não informado'}
            </Typography>
        </Box>
    );

    const BooleanField: React.FC<{ label: string; value: boolean | null }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Chip
                label={value === true ? 'Sim' : value === false ? 'Não' : 'Não informado'}
                color={value === true ? 'success' : value === false ? 'error' : 'default'}
                size="small"
            />
        </Box>
    );

    const ArrayField: React.FC<{ label: string; value: string[] | null }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            {value && value.length > 0 ? (
                <List dense>
                    {value.map((item, index) => (
                        <ListItem key={index} sx={{ pl: 0 }}>
                            <ListItemText primary={`• ${item}`} />
                        </ListItem>
                    ))}
                </List>
            ) : (
                <Typography variant="body1" color="textSecondary">
                    Não informado
                </Typography>
            )}
        </Box>
    );

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Órgãos Estaduais
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        EMPAER (Empresa Mato-grossense de Pesquisa, Assistência e Extensão Rural)
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Possui Escritório da EMPAER no Município"
                        value={formulario.possui_escritorio_empaer}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Quantidade de Escritórios"
                        value={formulario.quantidade_escritorios}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Desenvolve Projetos em Parceria com a EMPAER"
                        value={formulario.desenvolve_projetos_empaer}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Nome do Projeto EMPAER"
                        value={formulario.projeto_empaer_nome}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Possui Servidores Cedidos para a EMPAER"
                        value={formulario.servidores_cedidos_empaer}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <ArrayField
                        label="Nomes dos Servidores Cedidos para EMPAER"
                        value={formulario.nome_servidores_cedidos_empaer}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        INDEA (Instituto de Defesa Agropecuária de Mato Grosso)
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <BooleanField
                        label="Possui Escritório do INDEA no Município"
                        value={formulario.possui_escritorio_indea}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                        SEMA (Secretaria de Estado de Meio Ambiente)
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Possui Unidade da SEMA"
                        value={formulario.possui_unidade_sema}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Step3View; 